import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {UtilService} from '../../util/util.service';
import {ErrorVO} from '../../generate/ErrorVO';

@Component({
    selector: 'common-alerts',
    templateUrl: './common-alerts.component.html',
    styleUrls: ['./common-alerts.component.scss'],
    standalone: false
})
export class CommonAlertsComponent implements OnChanges {

  @Input()
  successMessage: string;

  @Input()
  errorMessage: string;

  @Input()
  errorsInput: string[];

  @Input()
  error: any;

  @Input()
  displayField: boolean;

  errorsList: string[] = [];


  constructor(private util: UtilService) {
  }

  ngOnChanges(changes: any): void {
    this.errorsList = [];
    if (this.error && this.error.errorCode === 400) {
      this.buildAllErrorMessages(this.error.message, this.errorsList);
    } else if (this.errorsInput && this.errorsInput.length > 0) {
      this.errorsList.push(...this.errorsInput);
    } else if (this.error) {
      // Handle SDK error format with detail field containing stringified JSON
      if (this.error.status >= 400 && this.error.status <= 499 && this.error.detail) {
        const errorMessage = this.util.extractSdkErrorMessage(this.error);
        if (errorMessage) {
          this.errorsList.push(errorMessage);
          return;
        }
      }

      // Handle ZodError validation errors which have stringified JSON array in message field
      if (this.error.message && typeof this.error.message === 'string') {
        try {
          const parsed = JSON.parse(this.error.message);
          if (Array.isArray(parsed)) {
            // Extract only the 'message' field from each validation error object
            parsed.forEach((err: any) => {
              if (err.message) {
                this.errorsList.push(err.message);
              }
            });
            return; // Successfully handled, exit early
          }
        } catch (e) {
          // Not valid JSON, fall through to default handling
        }
      }
      // Default: display the error message as-is, prioritizing detail over title
      this.errorsList.push(this.error.detail || this.error.message || this.error.title || 'An error occurred');
    }
  }


  buildAllErrorMessages(errors: ErrorVO, messages: string[]): string[] {
    for (const err of errors.errorMessages) {
      this.errorsList.push(err);
    }

    this.buildNonGlobalErrorMessages(errors, messages);

    if (messages.length === 1 && this.util.checkIfEmpty(messages[0])) {
      messages[0] = 'Something went wrong. Try again later.';
    }
    return messages;
  }

  private buildNonGlobalErrorMessages(errors: ErrorVO, messages: string[]) {
    for (const error of errors.errors) {
      if (error != null) {
        for (const err of error.errorMessages) {
          messages.push(this.displayField ? this.formatErrorMessageWithField(errors.field, error.field, err) : this.formatErrorMessage(error.field, err));
        }
      }
      this.buildNonGlobalErrorMessages(error, messages);
    }
  }


  private formatErrorMessage(field: string, error: string) {
    return field + ' error: ' + error;
  }

  private formatErrorMessageWithField(fieldRoot: string, field: string, error: string) {
    return field + ' in ' + fieldRoot + ' has an error message -' + error;
  }

}
